import { createSlice } from '@reduxjs/toolkit';
import { MapAnnotationsState } from './mapAnnotations.types';
import { MAP_ANNOTATIONS_SLICE_NAME } from './mapAnnotations.constants';
import {
  addMapAnnotationReducer,
  deleteMapAnnotationReducer,
  getMapAnnotationsReducer,
  updateMapAnnotationReducer,
} from './mapAnnotations.reducers';

const initialState: MapAnnotationsState = {
  data: {},
  loading: {},
  mutationLoading: {},
  error: null,
};

const mapAnnotationsSlice = createSlice({
  name: MAP_ANNOTATIONS_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: builder => {
    getMapAnnotationsReducer(builder);
    addMapAnnotationReducer(builder);
    updateMapAnnotationReducer(builder);
    deleteMapAnnotationReducer(builder);
  },
});

export default mapAnnotationsSlice.reducer;
